import {
    apiRequest,
    kursusUpdate
} from "../../../../../services/adapters/kepegawaian/kursusService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", kursusUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository